import LegalLayout from "@/components/mdh/LegalLayout";

export default function Privacy() {
    return (
        <LegalLayout title="Privacy Policy" updated="September 22, 2026" testid="privacy-page">
            <p>
                This Privacy Policy explains what information MDH-API ("we", "the Service")
                collects, how we use it, and the choices you have. It applies to{" "}
                <a href="https://mdhapi.com">mdhapi.com</a> and the MDH-API platform.
            </p>

            <h2>1. Information we collect</h2>
            <p>
                <strong>Account information:</strong> your name, email address, and — if you sign up
                through Google or GitHub — basic profile information from that provider.
            </p>
            <p>
                <strong>Phone number:</strong> only if you choose to provide it and explicitly opt
                in to SMS notifications.
            </p>
            <p>
                <strong>Service data:</strong> events, webhooks, monitoring results, and
                configuration you send through or store in the Service, plus security and sign-in
                activity (timestamps, IP addresses, device information) used to protect your
                account.
            </p>

            <h2>2. How we use it</h2>
            <p>
                We use this information to operate the Service: delivering your events, running
                your monitors, sending the alerts you configure, securing your account, and
                responding to support requests. We do not sell your personal information.
            </p>

            <h2>3. SMS data — our promise</h2>
            <p>
                Your phone number and SMS opt-in consent are used solely to send you the MDH-API
                notifications you asked for (webhook delivery alerts, endpoint and service status,
                security alerts, and account notifications).{" "}
                <strong>
                    We do not sell, rent, or share your phone number or SMS consent data with third
                    parties for their marketing purposes.
                </strong>{" "}
                Message frequency varies; message and data rates may apply. Reply STOP at any time
                to opt out, or HELP for help. You can also manage or disable SMS notifications in
                your account settings.
            </p>

            <h2>4. Sharing</h2>
            <p>
                We share information only with the service providers needed to operate the Service
                (for example, our messaging provider that delivers SMS and email on our behalf),
                and only for that purpose; or when required by law.
            </p>

            <h2>5. Retention and deletion</h2>
            <p>
                We keep account information while your account is active. You can revoke API
                tokens, sign out sessions, disable SMS alerts, or request account deletion at any
                time from your account settings or by contacting us.
            </p>

            <h2>6. Security</h2>
            <p>
                Passwords are hashed, API tokens are stored only as hashes, and sessions can be
                reviewed and revoked from your account's security page. No system is perfectly
                secure, but we design for least exposure.
            </p>

            <h2>7. Changes</h2>
            <p>
                If we make material changes to this Policy, we will announce them through the
                Service before they take effect.
            </p>

            <h2>8. Contact</h2>
            <p>
                Privacy questions: <a href="mailto:support@mdhapi.com">support@mdhapi.com</a>.
            </p>
        </LegalLayout>
    );
}
